enum VERTICALS {
    AEWATCH = '116',
    AUDIOBOOK = '162',
    AUTOMATION = '125',
    AUTOPARTS = '139',
    AUTOPARTSRA = '163',
    BILLING = '129',
    BROKERWATCH = '130',
    CARS = '106',
    COURTS = '143',
    CRUISES = '134',
    CYBERPRICE = '120',
    DRUGS = '126',
    FERRY = '151',
    FINANCIAL = '145',
    FLIGHTS = '102',
    HOMEGOODS = '159',
    HOMEIMPROVEMENT = '161',
    HOTELS = '107',
    JOURNALS = '140',
    NEWSWATCH = '114',
    RA = '164',
    RETAIL = '152',
    SOLUTIONS = '104',
    TIRES = '160',
    VACATION = '117',
}
export default VERTICALS;